<template>
  <div>
    <div>
      <img id="image_bg"/>
    </div>
    <div id="icp_footer">© 2018-2024 Ecscode.com 版权所有 <a
      href="https://beian.miit.gov.cn" target="_blank">滇ICP备18008686号</a></div>
  </div>
</template>

<script>
  export default {
    name: "SeaTree"
  }
</script>

<style scoped>
  #image_bg {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: url(../assets/bg.jpg) no-repeat center center fixed;
    background-size: cover;
  }
  #icp_footer {
    position: fixed;
    bottom: 0px;
    height: 20px;
    width: 100%;
    background-color: lightgrey;
    opacity: 0.6;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/SeaTree.vue